import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = ["id", "innerHTML"]

import axios from "axios"
  import { onMounted, ref } from "vue"
  import CardTemplate from "@/components/template/CardTemplate.vue"

  interface Props {
    htmlLink: string
    id: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InsightContainer',
  props: {
    htmlLink: null,
    id: null
  },
  setup(__props: any) {

const props = __props as {
    htmlLink: string
    id: string
  }

  

  onMounted(() => {
    fetchHTmlFile()
  })

  const content = ref()
  /**
   * Gets the html file from s3 and renders inside the post component
   */
  const fetchHTmlFile = async () => {
    try {
      const { data } = await axios.get(`https://assets.workbean.co/${props.htmlLink}`)
      content.value = data
      return data
    } catch (error) {
      content.value = "Post unavailable"
      return "Post unavailable"
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardTemplate, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          id: __props.id,
          class: "content-posting",
          innerHTML: content.value
        }, null, 8, _hoisted_2)
      ])
    ]),
    _: 1
  }))
}
}

})